import React from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { CgSearch } from "react-icons/cg";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { searchResult } from "../../../redux/products/productSlice";

const SearchModal = ({ showSearchModal, setShowSearchModal }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // handleSearch
  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(searchResult(e.target.value));
    navigate("/product/search");
  };

  return (
    <Modal show={showSearchModal} onHide={() => setShowSearchModal(false)}>
      <Modal.Body
        style={{ padding: "0.5rem " }}
        className="d-flex justify-content-center"
      >
        <Form
          className="search_container_mobile"
          onChange={(e) => handleSearch(e)}
        >
          <input type="text" placeholder="Search..." aria-label="Search" />
          <button type="submit">
            {" "}
            <CgSearch className="search_icon" />
          </button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default SearchModal;
